import React, { useState, useEffect, useContext, useRef } from 'react'
import axios from 'axios'
import { Table, Image, Input, Space, Button, message, Tag, Empty, Modal, Spin, Form, Select, DatePicker, Row, Col, Typography} from 'antd'
import moment from 'moment-timezone';
import dayjs from 'dayjs'

import { ExclamationCircleOutlined } from '@ant-design/icons';
const { Title } = Typography;
import { AppContext } from '../App';

export var fetchData = ''

const ListshareRateHistory = (revenueShareId) => {

  const { user } = useContext(AppContext);

  const API_URL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem('Authentication');

  const [data, setData] = useState([])
  const [messageApi, contextHolder] = message.useMessage();
  const [emptyBranch, setEmptyBranch] = useState(false)

  const [branchName,setBranchName] = useState('')
  const [form] = Form.useForm();
  const [totalRecord, setTotalRecord] = useState(0)

  const [openAddModal,setOpenAddModal] = useState(false)
  const [openDeleteModal,setOpenDeleteModal] = useState(false)
  const [openEditModal,setOpenEditModal] = useState(false)

  const revenueShareSelect = revenueShareId.revenueShareId
  const [shareRateSelect, setshareRateSelect] = useState()

  const [messageConfirmDelete, setMessageConfirmDelete] = useState('ยืนยันการลบส่วนแบ่ง')
  
  const columns = [
    {
        title: 'ลำดับ',
        width: 100,
        dataIndex: 'order',
        key: 'order',
        render: (text, record) => (
          <div>
            {text}
          </div>
        )    
    },
    {
      title: 'วันที่มีผล',
      width: 90,
      dataIndex: 'effectiveDate',
      key: 'effectiveDate',
      render: (text, record) => (
        <div>
            {moment.tz(moment(text), 'Asia/Bangkok').format('DD/MM/YYYY')}
        </div>
      ),
    },
    {
        title: 'ส่วนแบ่งสาขา',
        width: 80,
        dataIndex: 'shareRate',
        key: 'shareRate',
        render: (text, record) => (
          <div>
            {text}%
          </div>
        ),
    },
    {
      title: 'จัดการ',
      width: 90,
      dataIndex: 'id',
      key: 'action',
      render: (text, record) => (
        <div>
            { dayjs() < dayjs(record.effectiveDate) ? <Button onClick={ () => editFanshineShow(record.id, record.shareRate, dayjs(record.effectiveDate))} type='primary'>แก้ไข</Button> : '' } &nbsp;&nbsp;
            { totalRecord > 1 && dayjs() < dayjs(record.effectiveDate) ? <Button onClick={() => deleteshareRateShow(record.id)} danger>ลบ</Button> : '' }
        </div>
      ),
    }
  ]

  fetchData = async () => {

    setData('')
    try {
      const response = await axios.get(`${API_URL}getListRevenueShareRateHistory/${revenueShareSelect}`, {
        headers: {
          'Authorization': `bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })


      const adjustedData = response.data.listshareRateHistory.map((fanshine) => ({
        ...fanshine,
        key: fanshine.id,
      }));

      if(response.data.listshareRateHistory.length === 0){
        setEmptyBranch(true)
      }else{
        setEmptyBranch(false)
      }

      setTotalRecord(response.data.listshareRateHistory.length)

      if(response.data.branchName){
        setBranchName(response.data.branchName)
      }

      setData(adjustedData)
    } catch (error) {
      console.log('error', error)
    }
  }

    useEffect(() => { 
        fetchData(revenueShareSelect)
    }, [])


    const createNewFanshieFeeShow = async function (){
      setOpenAddModal(true)
      form.setFieldsValue({
        revenueShareId: revenueShareSelect
      })
    }

    const addshareRate = async function (values){
      try {
        const response = await axios.post(`${API_URL}createShareRate`, {
            revenueShareId: values.revenueShareId,
            shareRate: values.shareRate,
            effectiveDate: values.effectiveDate
        }, {
            headers: {
                'Authorization': `bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })

        if (response.status === 200) {
            messageApi.open({
                type: 'success',
                content: 'เพิ่มส่วนแบ่งสาขาเรียบร้อย',
            });
            fetchData()
        }
    } catch (error) {
        console.log(error);
    }
    }

    const editFanshineShow = async (revenueShareRateId, shareRate, effectiveDate) => {
        
        form.setFieldsValue({
            revenueShareRateId: revenueShareRateId,
            shareRate: shareRate,
            effectiveDate: effectiveDate
        });

        setOpenEditModal(true)
    }

    const editshareRate = async (values) => {
        try {
            const response = await axios.post(`${API_URL}editShareRate`, {
                revenueShareRateId: values.revenueShareRateId,
                shareRate: values.shareRate,
                effectiveDate: values.effectiveDate
            }, {
                headers: {
                    'Authorization': `bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })

            if (response.status === 200) {
                messageApi.open({
                    type: 'success',
                    content: 'แก้ไขส่วนแบ่งสาขาเรียบร้อย',
                });
                fetchData()
            }
        } catch (error) {
            console.log(error);
        }
    }

    const deleteshareRateShow = async (revenueShareRateId) => {
        setMessageConfirmDelete(`ยืนยันการลบส่วนแบ่งสาขา ?`)
        setshareRateSelect(revenueShareRateId)
        setOpenDeleteModal(true)
    }

    const deleteshareRate = async () => {
        try {
            const response = await axios.delete(`${API_URL}deleteShareRate/${shareRateSelect}`, {
              headers: {
                'Authorization': `bearer ${token}`,
                'Content-Type': 'application/json'
              }
            })
      
            if(response.status === 200){
                messageApi.open({
                    type: 'success',
                    content: 'ลบส่วนแบ่งสาขาเรียบร้อย',
                });
                fetchData()
            }

          } catch (error) {
            console.log('error', error)
          }
    }

  return (
    <div className="fetch-event-table">
      {contextHolder}
      {
        <Row >
          <Col span={21}><Title level={5}>สาขา: {branchName}</Title></Col>
          <Col span={2}><Button type='primary' onClick={() => createNewFanshieFeeShow()}>เพิ่มส่วนแบ่งใหม่</Button></Col>
        </Row>
      }
      {
        <Modal
        title="เพิ่มส่วนแบ่งสาขา"
        centered
        open={openAddModal}
        okText="ยืนยัน"
        cancelText="ยกเลิก"
        onOk={() => {
            form
                .validateFields()
                .then((values) => {
                    addshareRate(values)
                    form.resetFields();
                    setOpenAddModal(false);
                })
                .catch((errorInfo) => {
                    console.log('Failed:', errorInfo);
                });
        }}
        onCancel={() => {
            form.resetFields();
            setOpenAddModal(false);
        }}
        width={400}
    >
        <Form
            form={form}
            layout="vertical"
        >
            <Form.Item name="revenueShareId" hidden={true}>
                <Input type='hidden'/>
            </Form.Item>
            <Form.Item name="shareRate" label="ส่วนแบ่งสาขา (%)"
                rules={[
                    {
                        required: true,
                        message: 'กรุณากรอกส่วนแบ่งสาขา',
                    },
                ]}>
                <Input type='number' min={0} max={100} step={0.5}/>
            </Form.Item>
            <Form.Item name="effectiveDate" label="วันที่เริ่มเก็บค่าบริการ"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกวันที่เริ่มเก็บค่าบริการ',
                            },
                        ]}>
                <DatePicker/>
              </Form.Item>
        </Form>
        </Modal>
      }
      {
        <Modal
            title={
                <>
                    <ExclamationCircleOutlined style={{ color: 'red', marginRight: '8px' }} />
                    ลบส่วนแบ่งสาขา
                </>
            }
            centered
            open={openDeleteModal}
            okText="ยืนยัน"
            cancelText="ยกเลิก"
            onOk={() => {
                deleteshareRate()
                setOpenDeleteModal(false)
            }}
            onCancel={() => {
                setOpenDeleteModal(false);
            }}
            width={300}
        >
            {messageConfirmDelete}
        </Modal>
      }
      {
        <Modal
        title="แก้ไขค่าบริการ"
        centered
        open={openEditModal}
        okText="ยืนยัน"
        cancelText="ยกเลิก"
        onOk={() => {
            form
                .validateFields()
                .then((values) => {
                    editshareRate(values)
                    form.resetFields();
                    setOpenEditModal(false);
                })
                .catch((errorInfo) => {
                    console.log('Failed:', errorInfo);
                });
        }}
        onCancel={() => {
            form.resetFields();
            setOpenEditModal(false);
        }}
        width={400}
    >
        <Form
            form={form}
            layout="vertical"
        >
            <Form.Item name="revenueShareRateId" hidden={true}>
                <Input type='hidden'/>
            </Form.Item>
            <Form.Item name="shareRate" label="ส่วนแบ่งสาขา (%)"
                rules={[
                    {
                        required: true,
                        message: 'กรุณากรอกส่วนแบ่งสาขา',
                    },
                ]}>
                <Input type='number' min={0} max={100} step={0.5}/>
            </Form.Item>
            <Form.Item name="effectiveDate" label="วันที่เริ่มเก็บค่าบริการ"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกวันที่เริ่มเก็บค่าบริการ',
                            },
                        ]}>
                <DatePicker/>
              </Form.Item>
        </Form>
        </Modal>
      }

      {data && data.length > 0 ? (
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          scroll={{
            x: 400,
          }}
          rowKey="id"
        />
      ) : ( emptyBranch ? <p>ไม่พบข้อมูล</p> : <Spin />)
      }
    </div>
  )
}

export default ListshareRateHistory